export const getters = {
  MODE: state => !!state.theme.mode
}